import config from "../config"
const baseUrl = config.base_url + "buy_category/"
export default {
    page: {
        url: baseUrl + "page/{page}/{limit}",
        type: "get",
    },
    save: {
        url: baseUrl + "save",
        type: "post",
    },
    remove: {
        url: baseUrl + "delete",
        type: "get",
    },
    get: {
        url: baseUrl + "get",
        type: "get",
    },
    list: {
        url: baseUrl + "list",
        type: "get",
    }
}
